// Generated by Melange

import * as Buhta_components__ToastView from "./ToastView.js";
import * as JsxRuntime from "react/jsx-runtime";

function ToastContainer(Props) {
  let toast = Props.toast;
  let onExpired = Props.onExpired;
  let children = Props.children;
  return JsxRuntime.jsxs("div", {
    children: [
      children,
      JsxRuntime.jsx("div", {
        children: toast !== undefined ? JsxRuntime.jsx(Buhta_components__ToastView.make, {
            toast: toast,
            onExpired: onExpired
          }) : null,
        className: "absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2"
      })
    ],
    className: "relative"
  });
}

const make = ToastContainer;

export {
  make,
}
/* Buhta_components__ToastView Not a pure module */
